import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CardSliceContent } from '../../../types/prismic.types'
import { FC, useMemo } from 'react'
import { RichText } from 'prismic-reactjs'
import { SecondaryButton } from '@dtx-company/shared-components/src/components/atoms/Button/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { hexToRgb } from '@app/page/src/utils/theme'
import { prismicImageLoader } from '@app/common/src/utils/prismicImageLoader'
import Link from 'next/link'
import NextImage from 'next/image'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'

export interface ProUpsellBannerProps {
  data: CardSliceContent
  sectionId?: string
}

export const ProUpsellBanner: FC<ProUpsellBannerProps> = ({ data, sectionId }) => {
  const { r, g, b } = useMemo(
    () => hexToRgb(data.card_background_color),
    [data.card_background_color]
  )
  const backgroundGradient = `linear-gradient(270deg, rgba(${r}, ${g}, ${b}, 0), rgba(${r}, ${g}, ${b}, 1))`

  return (
    <Box
      backgroundColor={data.card_background_color}
      width="100%"
      pl="80px"
      height="min-content"
      id={sectionId}
    >
      <Box flexDirection="column" maxWidth="40%">
        <Spacer mt="16px" />
        <Text variant="display/small" as="h2" fontWeight="bold" color={data.card_font_color}>
          {RichText.asText(data.title)}
        </Text>
        <Spacer mt="4px" />
        <Text variant="body/medium" color={data.card_font_color}>
          {RichText.asText(data.description)}
        </Text>
        <Spacer mt="8px" />
        {data.link.url && (
          <>
            <Link href={data.link.url} data-heap-id="ProUpsellBannerLink" passHref legacyBehavior>
              <SecondaryButton
                width="max-content"
                border="none"
                backgroundColor={data.link_background_color}
                onClick={() => {
                  events.Flowcode_LoggedOutGenerator_Clicked_LowerBannerText({
                    linkText: RichText.asText(data.link_text)
                  })
                }}
              >
                <Text color={data.link_font_color} variant="button/general" fontWeight="bold">
                  {RichText.asText(data.link_text)}
                </Text>
              </SecondaryButton>
            </Link>
            <Spacer mt="16px" />
          </>
        )}
      </Box>

      <Box width="60%" borderWidth="2px">
        <Box display="block" position="relative" width="100%" minHeight="150px">
          {data.image.url && (
            <NextImage
              src={data.image.url}
              alt={data.image.alt || ''}
              loader={prismicImageLoader}
              fill
              sizes="50vw"
              style={{
                borderLeft: `2px solid ${data.card_background_color}`,
                objectFit: 'cover'
              }}
            />
          )}
          <Box
            display="block"
            position="absolute"
            background={backgroundGradient}
            top={0}
            left={0}
            right={0}
            bottom={0}
          />
        </Box>
      </Box>
    </Box>
  )
}
